import React from "react";

import Navbar3 from "../Components/Navbar3";
import FlagFootballProgramGrid from "../Components/FlagFootballProgramGrid";
import FlagFootballPrograms from "../data/FlagFootballPrograms";
import FlagFootballEvent from "../Components/FlagFootballEvent";
import TextDivider from "../Components/TextDivider";
import Footer from "../Components/Footer";

function FlagFootball() {
  return (
    <>
      <Navbar3 />

      {/* Flag Football Carousel */}
      {/* <div
        id="flagFootballCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="5000"
      > */}
        {/* Indicators */}
        {/* <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#flagFootballCarousel"
            data-bs-slide-to="0"
            className="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>

          <button
            type="button"
            data-bs-target="#flagFootballCarousel"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>

          <button
            type="button"
            data-bs-target="#flagFootballCarousel"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div> */}

        {/* Slides */}
        {/* <div className="carousel-inner"> */}

          {/* Slide 1 */}
          {/* <div className="carousel-item active">
            <picture>
              <source
                media="(max-width: 767px)"
                srcSet="/s3/flag-football-info-session-mobile.jpg"
              />

              <img
                src="/s3/flag-football-info-session.jpg"
                className="d-block w-100"
                alt="ADS Flag Football Information Sessions"
              />
            </picture>
          </div> */}

          {/* Slide 2 */}
          {/* <div className="carousel-item">
            <picture>
              <source
                media="(max-width: 767px)"
                srcSet="/s3/flag-football-registration-mobile.jpg"
              />

              <img
                src="/s3/flag-football-registration.jpg"
                className="d-block w-100"
                alt="ADS Flag Football Registration"
              />
            </picture>
          </div> */}

          {/* Slide 3 */}
          {/* <div className="carousel-item">
            <picture>
              <source
                media="(max-width: 767px)"
                srcSet="/s3/flag-football-mobile.jpg"
              />

              <img
                src="/s3/flag-football-mobile.jpg"
                className="d-block w-100"
                alt="ADS Flag Football"
              />
            </picture>
          </div> */}

        {/* </div> */}

        {/* Previous */}
        {/* <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#flagFootballCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button> */}

        {/* Next */}
        {/* <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#flagFootballCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div> */}

      <section className="camp-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="camp-section__title futuraPTMedium">
                FLAG FOOTBALL
              </h2>
            </div>
          </div>
        </div>
      </section>

      <FlagFootballProgramGrid
        programs={FlagFootballPrograms}
      />

      <FlagFootballEvent />

      <TextDivider />

      <Footer />
    </>
  );
}

export default FlagFootball;